import styled from 'styled-components';
import NextImage from 'next/image';

import { PaletteColor } from '@utils/types';

export const Label = styled.span<{
  backgroundColor?: PaletteColor;
  color?: PaletteColor;
  fontWeight?: string;
  borderColor?: PaletteColor;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  width: 80%;
  text-align: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 60px;
    width: 100%;
  }

  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor
      ? theme.palette[backgroundColor as PaletteColor]
      : theme.palette.lightSuccess};

  color: ${({ color, theme }) =>
    color ? theme.palette[color as PaletteColor] : theme.palette.darkSuccess};

  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight}`}
  font-size: 14px;

  ${({ theme, borderColor }) =>
    borderColor
      ? theme.palette[borderColor as PaletteColor]
      : theme.palette.darkSuccess};
`;
export const Image = styled(NextImage)`
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    right: 0;
  }
`;

export const Content = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 80%;
  }
`;

export const Title = styled.span`
  font-size: 30px;
  font-weight: 900;
  color: ${({ theme }) => theme.palette.tomato};
  z-index: 10;
`;

export const TextContent = styled.div`
  margin-left: 10px;
  margin-top: -2px;
  z-index: 10;
`;

export const Text = styled.span`
  font-size: 18px;
  line-height: 1.5;

  color: ${({ theme }) => theme.palette.darkGrey};
`;
export const Wrapper = styled.div`
  display: flex;
  margin-top: 35px;
  gap: 30px;
`;
export const ImageContainer = styled.div``;
